const app = {
    namespaced: true, // 为当前模块开启独立的 命名空间
    state: {
        topSearch: '',
        payVisible: false,
    },
    mutations: {
        SET_TOP_SEARCH: (state, topSearch) => {
            state.topSearch = topSearch
        },
        SET_PAY_VISIBLE: (state) => {
            state.payVisible = !state.payVisible
        }
    },
    actions: {

    },
}


export default app